<template>
    <div class="b-live w" @click="close()" id="clickMe">
        <div>
            <div id="menu">
                <div class="Shutup" @click="shutup()">全局禁言</div>
                <div class="updateShutup" @click="updateShutup()">禁言半小时</div>
            </div>
        </div>
        <div class="live-title">
            <div class="info-odds-box">
                <div class="info-box">
                    <div class="team-home">
                        <div class="left">
                            <div class="away-name name" v-html="matchinfo.homeName"></div>
                        </div>
                        <div class="team-icon">
                            <div>
                                <img class="away-img" :src="matchinfo.home_logo"
                                    onerror="javascript:this.src='//static.fly2a.com/static/image/b-live/no-img2.png'" />
                            </div>
                        </div>
                    </div>
                    <div class="team-center">
                        <div class="title-box">
                            <!-- <span v-if="matchinfo.league_name_zh === 'NBA'" class="event-year">2019-2020赛季</span>
              <span v-else class="event-year">2020赛季</span> -->
                            <span class="event-name" v-html="matchinfo.eventName"></span>
                        </div>
                        <div class="center-up">
                            <span class="event-date">{{ matchinfo.starttime_unix }}</span>
                            <!-- <span class="event-time">{{ matchinfo.start_time }}</span> -->
                        </div>
                        <div class="center-down">
                            <div class="score away-score">{{ matchinfo.home_score }}</div>

                            <div class="center-middle">
                                <span class="event-period">{{ matchinfo.stateName }}</span>&nbsp;
                                <span v-if="matchinfo.state >= 1 && matchinfo.state <= 7" class="event-countDown"
                                    style="display: inline-block">{{ matchinfo.surplus_time }}</span>
                                <span v-else class="event-countDown" style="display: none">{{
                                    matchinfo.surplus_time
                                    }}</span>
                            </div>
                            <div class="score home-score">{{ matchinfo.away_score }}</div>
                        </div>
                    </div>
                    <div class="team-away">

                        <div class="team-icon">
                            <div>
                                <img class="home-img" :src="matchinfo.away_logo"
                                    onerror="javascript:this.src='//static.fly2a.com/static/image/b-live/no-img2.png'" />
                            </div>
                        </div>
                        <div class="right">
                            <div class="home-name name" v-html="matchinfo.awayName"></div>
                        </div>
                    </div>
                </div>
                <div class="banner">
                    <img :src="banner.img_url" @click="jumpFn(banner.jump_url)" width="100%" />
                    <div class="analyst-box">
                        <img :src="ad_wx.pr" class="xiaoxin" />
                        <div class>
                            <div class="analyst-name">逛球街-{{ ad_wx.username }}</div>
                            <div class="describe">
                                添加管理员“{{
                                    ad_wx.username
                                }}”，免费为您开通智能AI，推荐人气专家，免费红单内料，并赠送666个逛球币。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="live-content">
            <div class="live-left">
                <div class="live-box">
                    <div class="live-tab">
                        <!-- tab栏 -->
                        <div :class="tab == 1 ? 'tab tab-1 active' : 'tab tab-1'" @click="tabBtn(1)">
                            <i class="iconfont">&#xeb24;</i>
                            <span>动画直播</span>
                        </div>
                        <div :class="tab == 2 ? 'tab tab-2 active' : 'tab tab-2'" @click="tabBtn(2)">
                            <i class="iconfont">&#xe629;</i>
                            <span>视频直播</span>
                            <!-- <span
                v-show="!!enableText"
                id="showAddUrlBtn"
                @click.stop="showAddUrl"
                >{{ enableText }}</span
              > -->
                        </div>
                        <div class="video-origin-list">
                            <div class="video-origin" @click="tabCurrUrl(item)" @dblclick="updateUrl(item)"
                                v-for="(item, index) in tvlines" :key="index">
                                <img :title="item.username" :src="item.face" alt
                                    :class="item.id == tv_pitch_On ? 'pitchOn' : ''" />
                            </div>
                        </div>
                        <a class="video-origin vip" style="display: block"
                            :href="`/zonghe/recommend?id=${matchinfo.vip_member.tournament_id}`" target="_blank"
                            v-if="!!matchinfo.vip_member">
                            <img :title="matchinfo.vip_member.username" :src="matchinfo.vip_member.face" alt />
                        </a>
                    </div>
                    <div class="live-iframe">
                        <!-- 动画/视频栏 -->
                        <div class="tab tab-1" v-show="tab == 1">
                            <iframe id="iframe1" width="748" height="427" frameborder="no" scrolling="no"></iframe>
                        </div>
                        <div class="tab tab-2" v-show="tab == 2">
                            <iframe id="iframe2" width="748" height="427" frameborder="no" scrolling="no"
                                allow="autoplay; fullscreen" allowfullscreen></iframe>
                            <div class="tv_outer" v-if="tvlines.length > 1">
                                <div class="tv_title">尊上请您选择幸运主播</div>
                                <div class="tv-list-wrap">
                                    <div class="tv_select" v-for="(item, index) in tvlines" :key="index"
                                        @click="tabCurrUrl(item)">
                                        <div class>
                                            <img :src="item.face" />
                                        </div>
                                        <div class="tv_username">{{ item.username }}</div>
                                        <div class="tv_label" v-if="item.label" v-html="handleLabel(item.label)"></div>
                                    </div>
                                    <a class="tv_select vip" target="_blank"
                                        :href="`/zonghe/recommend?id=${matchinfo.vip_member.tournament_id}`"
                                        v-if="!!matchinfo.vip_member">
                                        <div class="vip_img">
                                            <img :src="matchinfo.vip_member.face" />
                                        </div>
                                        <div class="tv_username">
                                            {{ matchinfo.vip_member.username }}
                                        </div>
                                        <div class="tv_label" v-if="matchinfo.vip_member.label"
                                            v-html="handleLabel(matchinfo.vip_member.label)"></div>
                                    </a>
                                </div>
                            </div>
                            <div class="swiper-container" id="noZhibo" v-if="tvlines.length == 0">
                                <div class="swiper-wrapper" style="width: 748px; height: 426px">
                                    <div class="swiper-slide" style="width: 748px; height: 426px">
                                        <img src="//static.fly2a.com/static/image/b-live/zhubo-no.png" />
                                    </div>
                                </div>
                            </div>
                            <!-- END 内嵌主播视频 -->
                        </div>
                        <div class="move-ad"></div>
                        <!-- 178广告  30秒弹出-->
                        <ad-popup></ad-popup>
                        <el-dialog top="0" width="488px" custom-class="modal" title="开播/下播" :lock-scroll="false"
                            :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body="false"
                            :append-to-body="false" :visible.sync="modal.visible" @close="modal.visible = false">
                            <div class="modal-form">
                                <input type="text" placeholder="请输入直播链接" v-model="modal.data.url" />
                                <select v-model="modal.data.member_id" v-if="modal.options.length > 0"
                                    placeholder="请选择主播">
                                    <option v-for="item in modal.options" :key="item.member_id" :value="item.member_id">
                                        {{ item.username }}
                                    </option>
                                </select>
                            </div>
                            <div class="modal-button">
                                <button type="button" @click="createUrl">
                                    {{ modal.data.tvid ? "修改" : "开播" }}
                                </button>
                                <button style="margin-left: 20px" type="button" v-show="!!modal.data.tvid"
                                    @click="removeUrl">
                                    下播
                                </button>
                            </div>
                        </el-dialog>
                    </div>
                    <div class="live-info">
                        <!-- 球赛即时信息 -->
                        <!-- 二层 -->
                        <div class="info-two">
                            <div class="two-left">
                                <span class="away">
                                    <span class="img-box">
                                        <img class="team-img" :src="matchinfo.home_logo"
                                            onerror="javascript:this.src='//static.fly2a.com/static/image/b-live/no-img2.png'" />
                                    </span>
                                    <span class="away-name name" v-html="matchinfo.homeName"></span>

                                </span>
                            </div>
                            <div class="two-center" id="bar-0">
                                <div class="up">
                                    <span class="event-period">{{ matchinfo.stateName }}</span>
                                    &nbsp;
                                    <span v-if="matchinfo.state >= 1 && matchinfo.state <= 7" class="event-countDown"
                                        style="display: inline-block">{{ matchinfo.surplus_time }}</span>
                                    <span v-else class="event-countDown" style="display: none"></span>
                                </div>
                                <div class="down">
                                    <span class="score">
                                        <span class="away-score">{{ matchinfo.home_score }}</span>
                                    </span>
                                    <span class="center">:</span>
                                    <span class="score">
                                        <span class="home-score">{{ matchinfo.away_score }}</span>
                                    </span>

                                </div>
                            </div>
                            <div class="two-right">
                                <span class="home">
                                    <span class="home-name name" v-html="matchinfo.awayName"></span>
                                    <span class="img-box">
                                        <img class="team-img" :src="matchinfo.away_logo"
                                            onerror="javascript:this.src='//static.fly2a.com/static/image/b-live/no-img2.png'" />
                                    </span>
                                </span>
                            </div>

                        </div>
                        <!-- 三层 -->
                        <div class="info-three">
                            <div class="three-left">
                                <!--<div class="tr-away">
                                    <span>暂停</span>
                                    <span class="pause-num">0</span>
                                </div>-->
                                <div class="tr-away">
                                    <span>犯规</span>
                                    <span class="ill-num">{{ matchinfo.home_foul }}</span>
                                </div>
                            </div>
                            <div class="three-middle">
                                <span id="bar-1">
                                    <span class="left">
                                        <span class="num">{{ matchinfo.home_threemin_hit }}</span>
                                        <span class="bar">
                                            <span class="bar-live" style="width: 50%"></span>
                                        </span>

                                    </span>
                                    <span class="center">3分球得分</span>
                                    <span class="right">
                                        <span class="bar">
                                            <span class="bar-live" style="width: 50%"></span>
                                        </span>
                                        <span class="num">{{ matchinfo.away_threemin_hit }}</span>
                                    </span>

                                </span>
                                <span id="bar-2">
                                    <span class="left">
                                        <span class="num">{{ matchinfo.home_two_points }}</span>
                                        <span class="bar">
                                            <span class="bar-live" style="width: 50%"></span>
                                        </span>
                                    </span>
                                    <span class="center">2分球得分</span>

                                    <span class="right">

                                        <span class="bar">
                                            <span class="bar-live" style="width: 50%"></span>
                                        </span>
                                        <span class="num">{{ matchinfo.away_two_points }}</span>
                                    </span>
                                </span>
                                <span id="bar-3">
                                    <span class="left">
                                        <span class="num">{{ matchinfo.home_punishball_hit }}</span>
                                        <span class="bar">
                                            <span class="bar-live" style="width: 50%"></span>
                                        </span>

                                    </span>
                                    <span class="center">
                                        <span class="rnum">{{ matchinfo.home_hit_rate }}%</span>
                                        <span>罚球</span>
                                        <span class="lnum">{{ matchinfo.away_hit_rate }}%</span>

                                    </span>
                                    <span class="right">
                                        <span class="bar">
                                            <span class="bar-live" style="width: 50%"></span>
                                        </span>
                                        <span class="num">{{ matchinfo.away_punishball_hit }}</span>
                                    </span>

                                </span>
                            </div>
                            <div class="three-right">
                                <!--<div class="tl-home">
                                    <span>暂停</span>
                                    <span class="pause-num">0</span>
                                </div>-->
                                <div class="tl-home">
                                    <span>犯规</span>
                                    <span class="ill-num">{{ matchinfo.away_foul }}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="live-right" id="noHaveToken">
                <!-- <div class="upgradeShow">
                    <img src="//static.fly2a.com/static/image/f-live/upgrading.png" />
                    <br />
                    <span>聊天室正在升级</span>
                </div>
                <div class="char-box">
                    <div class="title">
                        <span class="chatname">
                            <img src="//static.fly2a.com/gqj_tv/image/chats.png" alt width="16px" />&ensp;
                            <span>{{ currAnchor.name ? currAnchor.name : "" }}</span>
                            <span>{{ currAnchor.name ? "的" : "" }}聊天室</span>
                        </span>
                        <span class="count">
                            <img src="//static.fly2a.com/006zhibo/image/eye.png" alt width="16px" />
                            <span class="text">{{ viewerFn(currAnchor.room_user_num) }}</span>
                        </span>
                    </div>
                    <div class="msg-list">
                        <div class="follow" v-if="currAnchor.name != '公共' && currAnchor.type == 2" @mousemove="qrcodeShow($event)" @mouseleave="qrcodeHide()">
                            <div class="anchor">
                                <img :src="currAnchor.face" alt />
                                <span>
                                    <span class="name">{{ currAnchor.name }}</span>
                                    <br />
                                    <span class="wx" v-if="currAnchor.wx_num">
                                        <span>账号:{{ currAnchor.wx_num }}</span>
                                    </span>
                                </span>
                            </div>
                            <div :class="currAnchor.isnofollow ? 'follow_btn' : 'follow_btn active'" v-html="follow_html(currAnchor.isnofollow)" @click="followFn()" v-if="currAnchor.member_id != getCookie('member_id')"></div>
                            <div class="follow_msg" v-if="follow_msg">{{ follow_msg }}</div>
                            <div class="wx_qrcode" v-show="currAnchor.wx_code && qrcode_show">
                                <div>
                                    <img :src="currAnchor.wx_code" alt />
                                </div>
                                <div class="wx_qrcode_title">
                                    扫一扫
                                    <br />加主播账号
                                </div>
                            </div>
                        </div>
                        <div>
                            <span style="display: flex; flex-direction: row">
                                <i class="iconfont hornicon" style="color: #e84d5d">&#xe8e8;</i>&ensp;
                                <marquee class="horn" style="color: #e84d5d">{{
                                    matchinfo.room_notice || commonChatroomNotice
                                    }}</marquee>
                            </span>
                        </div>
                        <ul id="dialog" class="per-content" :style="currAnchor.name != '公共' && currAnchor.type == 2 ? 'top: 77px;' : 'top: 28px;'"></ul>
                    </div>
                    <div class="msg-post">
                        <textarea class="msg-content" placeholder="请输入..." id="textarea"></textarea>
                        <div class="say-btn">
                            <div class="shield" v-if="shield.show">
                                <div @click="shieldFn()">
                                    <span>
                                        <i class="iconfont2" v-if="!shield.shieldALL"></i>
                                    </span>
                                    <img src="//static.fly2a.com/006zhibo/image/checked.png" alt v-if="shield.shieldALL" width="16px" />
                                    <span>屏蔽所有入场消息</span>
                                </div>
                            </div>
                            <img :src="shield.shieldALL || shield.shieldYK ? '//static.fly2a.com/gqj_tv/image/shield2.png' : '//static.fly2a.com/gqj_tv/image/shield1.png'" @click="shield.show = !shield.show" width="22px" />
                            <i class="iconfont btn btn-default face-btn face pull-left">&#xe656;</i>
                            <input type="submit" class="btn btn-default submit-btn" value="发表" id="subBtn" @click="onSubmit()" />
                        </div>
                    </div>
                </div> -->
                <ChatRoom :curTv="currAnchor" :match="matchinfo" />
            </div>
        </div>
        <div class="live-text">
            <div class="title"></div>
            <div class="middle">
                <ul class="event-text t-tab1" style="display: none"></ul>
                <ul class="event-text t-tab2" style="display: none"></ul>
                <ul class="event-text t-tab3" style="display: none"></ul>
                <ul class="event-text t-tab4" style="display: none"></ul>
                <ul class="event-text t-tab5" style="display: none"></ul>
                <ul class="event-text t-tab6" style="display: none"></ul>
                <ul class="event-text t-tab7" style="display: none"></ul>
                <ul class="event-text t-tab-1" style="display: none"></ul>
                <img src="//static.fly2a.com/static/image/no-data.png" class="noData-img" style="display: block" />
            </div>
        </div>
        <!-- 球队数据统计 -->
        <div class="live-statistics home-statistics">
            <div class="title-img">
                <div class="img-box">
                    <img :src="matchinfo.home_logo"
                        onerror="javascript:this.src='//static.fly2a.com/static/image/b-live/no-img2.png'" />
                </div>
                <span class="home-name" v-html="matchinfo.homeName"></span>
            </div>
            <div class="statistics-inner">
                <div class="list">
                    <div class="title row">
                        <div class="w-50">
                            <span>背号</span>
                        </div>
                        <div class="w-180 titleName">
                            <span>姓名</span>
                        </div>
                        <div class="w-100">
                            <span>首发</span>
                        </div>
                        <div class="w-100">
                            <span>出场时间</span>
                        </div>
                        <div class="w-70">
                            <span>位置</span>
                        </div>
                        <div class="w-70">
                            <span>投篮</span>
                        </div>
                        <div class="w-70">
                            <span>三分</span>
                        </div>
                        <div class="w-70">
                            <span>罚球</span>
                        </div>
                        <div class="w-70">
                            <span>进攻篮板</span>
                        </div>
                        <div class="w-70">
                            <span>守护篮板</span>
                        </div>
                        <div class="w-55">
                            <span>助攻</span>
                        </div>
                        <div class="w-55">
                            <span>抢断</span>
                        </div>
                        <div class="w-55">
                            <span>盖帽</span>
                        </div>
                        <div class="w-55">
                            <span>失误</span>
                        </div>
                        <div class="w-55">
                            <span>犯规</span>
                        </div>
                        <div class="w-58">
                            <span>得分</span>
                        </div>
                    </div>
                    <div class="horizontal home-h"></div>
                    <div class="vertical home-v"></div>
                </div>
                <div class="summary">
                    <div class="subtitle row">
                        <span class="w-100">得分</span>
                        <span class="w-100">助攻</span>
                        <span class="w-100">篮板</span>
                        <!--<span class="w-180">前-后篮板</span>-->
                        <span class="w-100">抢断</span>
                        <span class="w-100">盖帽</span>
                        <span class="w-100">投篮(中-投)</span>
                        <span class="w-100">三分(中-投)</span>
                        <span class="w-100">罚球(中-投)</span>
                        <span class="w-100">失误</span>
                        <span class="w-100">犯规</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="live-statistics away-statistics">
            <div class="title-img">
                <div class="img-box">
                    <img :src="matchinfo.away_logo"
                        onerror="javascript:this.src='//static.fly2a.com/static/image/b-live/no-img2.png'" />
                </div>
                <span class="away-name" v-html="matchinfo.awayName"></span>
            </div>
            <div class="statistics-inner">
                <div class="list">
                    <div class="title row">
                        <div class="w-50">
                            <span>背号</span>
                        </div>
                        <div class="w-180 titleName">
                            <span>姓名</span>
                        </div>
                        <div class="w-100">
                            <span>首发</span>
                        </div>
                        <div class="w-100">
                            <span>出场时间</span>
                        </div>
                        <div class="w-70">
                            <span>位置</span>
                        </div>
                        <div class="w-70">
                            <span>投篮</span>
                        </div>
                        <div class="w-70">
                            <span>三分</span>
                        </div>
                        <div class="w-70">
                            <span>罚球</span>
                        </div>
                        <div class="w-70">
                            <span>进攻篮板</span>
                        </div>
                        <div class="w-70">
                            <span>守护篮板</span>
                        </div>
                        <!--<div class="w-70"><span>总篮板</span></div>-->
                        <div class="w-55">
                            <span>助攻</span>
                        </div>
                        <div class="w-55">
                            <span>抢断</span>
                        </div>
                        <div class="w-55">
                            <span>盖帽</span>
                        </div>
                        <div class="w-55">
                            <span>失误</span>
                        </div>
                        <div class="w-55">
                            <span>犯规</span>
                        </div>
                        <div class="w-58">
                            <span>得分</span>
                        </div>
                    </div>
                    <div class="horizontal away-h"></div>
                    <div class="vertical away-v"></div>
                </div>
                <div class="summary">
                    <div class="subtitle row">
                        <span class="w-100">得分</span>
                        <span class="w-100">助攻</span>
                        <span class="w-100">篮板</span>
                        <!--<span class="w-180">前-后篮板</span>-->
                        <span class="w-100">抢断</span>
                        <span class="w-100">盖帽</span>
                        <span class="w-100">投篮(中-投)</span>
                        <span class="w-100">三分(中-投)</span>
                        <span class="w-100">罚球(中-投)</span>
                        <span class="w-100">失误</span>
                        <span class="w-100">犯规</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
// import {
//     onChatroomConnect,
//     onCanConnect,
//     onChatroomDisconnect,
//     onSubmit,
//     markChatroomGaglist,
//     updateChatroomMemberTempMute,
//     scrollToLocation,
// } from "@/assets/js/chatroom.js";
import ChatRoom from "@/components/chatroom-v2/index"
import adPopup from "@/components/components/adPopup";

//import Swiper from "swiper";
var stateName = {
    0: "未开赛",
    1: "第一节",
    2: "第二节",
    3: "第三节",
    4: "第四节",
    5: "加时",
    6: "加时",
    7: "加时",
    "-1": "完场",
    "-2": "待定",
    "-3": "中断",
    "-4": "取消",
    "-5": "推迟",
    50: "中场",
};
var stateNameNcaa = {
    0: "未开赛",
    1: "上半场",
    3: "下半场",
    5: "加时",
    6: "加时",
    7: "加时",
    "-1": "完场",
    "-2": "待定",
    "-3": "中断",
    "-4": "取消",
    "-5": "推迟",
    50: "中场",
};

export default {
    components: {
        ChatRoom,
        adPopup
    },
    data() {
        return {
            ids: this.$route.query.id,
            zhibos: this.$route.query.zhibo, //0无直播,1有直播
            tvid: this.$route.query.tvid,
            currAnchor: {
                member_id: 0,
                name: "公共",
                room_user_num: "",
                roomid: 0,
                room_id: 0,
                face: "",
                isnofollow: 1,
                wx_num: "",
                type: 0,
                wx_code: "",
                qrcode: '',
            },
            qrcode_show: 0,
            follow_msg: "",
            follow: [],
            matchinfo: {
                home_team: {},
                events: {},
                away_team: {},
                state: 0,
            },
            chatroomid: 0,
            submiting: 0,
            memberType: 0,
            member_id: 0, //选中主播id
            sortArr: [1, 2, 3],
            tvlines: [],
            ad_wx: {
                pr: "//static.fly2a.com/static/image/fbCommon/xiaoxin.jpg",
                name: "gqj8800",
                username: "漠柯",
            },
            shield: {
                shieldYK: false,
                shieldALL: false,
                show: false,
            },
            banner: {
                jump_url: "#",
                img_url: "//static.fly2a.com/gqj_tv/banner.png",
            },
            tv_pitch_On: 0,
            tab: 1,
            headCon: headCon(),
            netease_im_token: "",
            timing: 0,
            wx_login_t: 0,

            modal: {
                options: [],
                data: {
                    tvid: "",
                    url: "",
                },
                visible: false,
            },
        };
    },
    computed: {
        ...mapState(["minfo"]),
        enableText() {
            const { minfo, matchinfo } = this;
            const tv = matchinfo.tv || [];
            if (minfo.type == 9) {
                return "开播/下播";
            } else if (minfo.type == 2) {
                const exist = tv.some((v) => v.member_id == minfo.member_id);
                if (matchinfo.state >= 0) {
                    if (exist || tv.length < 5) {
                        return "开播/下播";
                    }
                } else if (exist) {
                    return "下播";
                }
            }
            return "";
        },
    },
    watch: {
        "currAnchor.member_id"(newVal) {
            if (this.follow.indexOf(newVal) != -1) {
                this.currAnchor.isnofollow = 0;
            }
        },
    },
    created() {
        if (this.ids) {
            this.tab = this.zhibos ? 1 : 2;
            var shield = window.localStorage.getItem("shield");
            if (shield == 1) {
                this.shield.shieldALL = true;
            }
            if (this.getCookie("type")) {
                this.memberType = this.getCookie("type");
                this.getFollowAnchor();
            }
            //      this.request("basketball/matches?id="+this.ids, this.getMatchinfo);   // 比赛详情
            this.request("getdetail?id=" + this.ids + "&type=1", this.getMatchinfo); // 比赛详情
            this.request("basketball_technical?id=" + this.ids, this.getPlayers); // 比赛球员详情
            //        this.request("get_ad_list", this.getAd)
        }
    },
    beforeMount() {
        var wx_login_t = this.$route.query.wx_login_t;
        if (wx_login_t) {
            this.wx_login_t = 1;
            var href = location.href;
            if (location.href.indexOf("&") == -1) {
                href = href.replace("?wx_login_t=" + wx_login_t, "");
            } else {
                href = href.replace("&wx_login_t=" + wx_login_t, "");
                href = href.replace("wx_login_t=" + wx_login_t + "&", "");
            }
            history.pushState("", "", href);
        }
    },
    mounted() {
        $(".haed_lanqiu").addClass("nuxt-link-exact-active");
        var that = this;
        setTimeout(function () {
            window.addEventListener("beforeunload", function () {
                if (that.member_id) {
                    axios.post(
                        COMMOND.NEW_BASE_URL + "add_sta",
                        "type=2&page=lanqiu_live&device=pc&tournament_id=" +
                        that.ids +
                        "&member_id=" +
                        that.member_id
                    );
                }
            });
        }, 1000);
        this.chat_click();
    },
    methods: {
        followFn() {
            if (!this.netease_im_token || this.netease_im_token == 1) {
                if (!this.netease_im_token) {
                    $(".loading").show();
                    $(".loading_content1").show();
                    $(".zhuce").show();
                    $(".loading_content2").hide();
                    //            $(".authimg").attr("src", COMMOND.NEW_BASE_URL  + "get_img_code?"+Math.random()*10000);
                }
                return;
            }
            var token = this.getCookie("token");
            var type = 0;
            axios
                .post(
                    COMMOND.NEW_BASE_URL + "follow_anchor", {
                    member_id: this.currAnchor.member_id,
                    is_follow: this.currAnchor.isnofollow,
                }, {
                    headers: {
                        Authorization: token,
                    },
                }
                )
                .then((res) => {
                    if (res.data.code == 200) {
                        if (this.currAnchor.isnofollow) {
                            this.currAnchor.isnofollow = 0;
                            this.follow.push(this.currAnchor.member_id);
                            this.followMsg("关注成功");
                        } else {
                            this.currAnchor.isnofollow = 1;
                            this.follow.splice(
                                this.follow.indexOf(this.currAnchor.member_id),
                                1
                            );
                            this.followMsg("取消关注成功");
                        }
                    } else {
                        this.followMsg(res.data.msg);
                    }
                });
        },
        followMsg(msg) {
            var that = this;
            this.follow_msg = msg;
            setTimeout(function () {
                that.follow_msg = "";
            }, 1500);
        },
        getFollowAnchor() {
            var token = this.getCookie("token");
            axios
                .get(COMMOND.NEW_BASE_URL + "get_anchor_ids", {
                    headers: {
                        Authorization: token,
                    },
                })
                .then((res) => {
                    var data = res.data.data;
                    this.follow = data;
                    //            for (var i=0; i<data.length; i++) {
                    //              this.follow.push(data[i].member_id)
                    //            }
                });
        },
        follow_html(type) {
            if (type) {
                return '<span class="follow_add">+</span><span>关注</span>';
            }
            return "已关注";
        },
        qrcodeShow(e) {
            var positionX = e.pageX - $(".follow").offset().left; //获取当前鼠标相对img的X坐标
            if (positionX > 0) {
                this.qrcode_show = 1;
                //          $(".wx_qrcode").css("left",(positionX-54)+"px")
            } else {
                this.qrcode_show = 0;
            }
        },
        qrcodeHide() {
            this.qrcode_show = 0;
        },
        viewerFn(viewer) {
            if (viewer > 10000) {
                return (viewer / 10000).toFixed(2) + "万";
            } else {
                return viewer;
            }
        },
        // shieldFn() {
        //     if (this.shield.shieldALL) {
        //         window.localStorage.setItem("shield", 0);
        //         //          $(".msg-list .per-content li.enter").css("display","block");
        //     } else {
        //         window.localStorage.setItem("shield", 1);
        //         //          $(".msg-list .per-content li.enter").css("display","none");
        //     }
        //     this.shield.shieldALL = !this.shield.shieldALL;
        //     this.shield.show = false;
        //     this.$nextTick(function() {
        //         scrollToLocation();
        //     });
        // },
        onSubmit() {
            if (!this.netease_im_token || this.netease_im_token == 1) {
                if (!this.netease_im_token) {
                    $(".loading").show();
                    $(".loading_content1").show();
                    $(".zhuce").show();
                    $(".loading_content2").hide();
                    $(".authimg").attr(
                        "src",
                        COMMOND.NEW_BASE_URL + "get_img_code?" + Math.random() * 10000
                    );
                } else {
                    layer.tips("暂无聊天室", $("#textarea"), {
                        tips: [4, "#e24949"],
                        time: 3000,
                    });
                }
                return;
            }
            onSubmit();
        },
        chat_click() {
            $(".face").click(function (event) {
                $(this).sinaEmotion($("textarea"));
                event.stopPropagation();
            });
            // 回车发送
            $("textarea").on("keydown", function (e) {
                if (e.keyCode === 13 && !e.ctrlKey) {
                    // 按enter键提交
                    var nowTime = new Date().getTime();
                    var clickTime = $(this).attr("ctime");
                    if (clickTime != "undefined" && nowTime - clickTime < 3000) {
                        //禁止连续发言
                        layer.tips("客官,说话太快啦(つД`)", this, {
                            tips: [4, "#e24949"],
                            time: 5000,
                        });
                    } else {
                        e.preventDefault();
                        $("#subBtn").click();
                        $(this).attr("ctime", nowTime);
                    }
                    if (!$(this).val()) {
                        layer.tips("不可为空", this, {
                            tips: [4, "#e24949"],
                            time: 5000,
                        });
                    }
                }

                // 按ctrl+enter组合键换行
                if (e.keyCode === 13 && e.ctrlKey) {
                    $(this).val(function (i, val) {
                        return val + "\n";
                    });
                }
            });
        },
        request(url, fn) {
            url = COMMOND.NEW_BASE_URL + url;
            axios.get(url).then((res) => {
                if (fn) {
                    fn(res.data);
                }
            });
        },
        getAd(data) {
            if (data.code == 200) {
                var top = data.data.top;
                if (top && top.img_url) {
                    this.banner = {
                        jump_url: top.jump_url,
                        img_url: top.img_url,
                    };
                }
            }
        },
        jumpFn(jump_url) {
            if (jump_url && jump_url != "#") {
                window.open(jump_url);
            }
        },
        getMatchinfo(data) {
            var re = data.data;
             this.currAnchor.room_notice = re.room_notice;
            if (re.ad_wx) {
                this.ad_wx = re.ad_wx;
            }
            if (re.ad) {
                this.banner = {
                    jump_url: re.ad.jump_url,
                    img_url: re.ad.img_url,
                };
                this.banner.img_url =
                    "https://static.fly2a.com/gqj_tv/live/banner.png";
            }

            function timestampToTime(timestamp) {
                //时间戳方法
                var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-"; //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var M =
                    (date.getMonth() + 1 < 10 ?
                        "0" + (date.getMonth() + 1) :
                        date.getMonth() + 1) + "-";
                var D =
                    date.getDate() < 10 ?
                        "0" + date.getDate() + " " :
                        date.getDate() + " ";
                return Y + M + D;
            }

            function formatSeconds(value) {
                //秒转时分秒
                var theTime = parseInt(value);
                var theTime1 = 0;
                if (theTime > 60) {
                    theTime1 = parseInt(theTime / 60);
                    theTime = parseInt(theTime % 60);
                    if (theTime1 > 60) {
                        theTime1 = parseInt(theTime1 % 60);
                    }
                }
                if (parseInt(theTime) < 10) {
                    var resultTime = "0" + parseInt(theTime);
                } else {
                    var resultTime = "" + parseInt(theTime);
                }
                if (theTime1 > 0) {
                    if (parseInt(theTime1) < 10) {
                        resultTime = "0" + parseInt(theTime1) + ":" + resultTime;
                    } else {
                        resultTime = "" + parseInt(theTime1) + ":" + resultTime;
                    }
                } else {
                    resultTime = "00" + ":" + resultTime;
                }
                return resultTime;
            }

            re.starttime_unix = this.$format(re.start_time_int, "YYYY-MM-DD HH:mm");
            var langChange = localStorage.getItem("langChange");
            re.homeName =
                langChange == 1 ?
                    re.home_team_zht ?
                        re.home_team_zht :
                        re.home_team_zh :
                    re.home_team_zh; //默认简体
            re.awayName =
                langChange == 1 ?
                    re.away_team_zht ?
                        re.away_team_zht :
                        re.away_team_zh :
                    re.away_team_zh;
            re.eventName =
                langChange == 1 ?
                    re.league_name_zht ?
                        re.league_name_zht :
                        re.league_name_zh :
                    re.league_name_zh;
            //        re.stateName = stateName[re.state]; //状态
            re.league_id === 8 ?
                (re.stateName = stateNameNcaa[re.state]) :
                (re.stateName = stateName[re.state]); //状态

            if (re.localtime > 0) {
                //倒计时
                re.localtime = formatSeconds(re.localtime);
            }
            this.matchinfo = re;
            this.setCookie1("roomid", this.matchinfo.roomid);
            this.$nextTick(function () {
                var title = this.headCon["lanqiu"]["live"]["title"];
                this.headCon["lanqiu"]["live"]["title"] = title
                    .replace("{awayName}", this.matchinfo.awayName)
                    .replace("{homeName}", this.matchinfo.homeName);
                this.live_ajax(parseInt(this.ids));
                this.adv2();
                this.swippertab();
                if (this.matchinfo.tv) {
                    this.tvlines = this.matchinfo.tv;
                    if (this.matchinfo.tv.length > 1) {
                        this.$nextTick(function () {
                            if (!this.wx_login_t) {
                                layer.tips("点这切换主播哦!", ".live-tab .video-origin", {
                                    tips: [1, "#f93c3c"],
                                    time: 2000,
                                    offset: ["100px", "50px"],
                                });
                            }
                        });
                    }
                    if (this.tvid) {
                        for (var i = 0; i < this.tvlines.length; i++) {
                            if (this.tvlines[i].id == this.tvid) {
                                this.tabCurrUrl(this.tvlines[i]);
                                this.tvid = 0;
                                break;
                            }
                            if (i == this.tvlines.length - 1) {
                                this.tvid = 0;
                                history.pushState("", "", "/lanqiu/live?id=" + this.ids);
                                this.tabBtn(2);
                            }
                        }
                    } else {
                        this.tabBtn(2);
                    }
                } else {
                    history.pushState("", "", "/lanqiu/live?id=" + this.ids);
                    this.tabBtn(1);
                }
                var that = this;
                setTimeout(function () {
                    that.timing = 1;
                }, 500);
                $("footer").show();
            });
        },
        getPlayers(data) {
            var re = data.data;
            //球员数据players[0]主 players[1]客
            if (re.tlive) {
                //球员数据统计
                var fen_arr = {
                    zhu: {
                        score: 0,
                        helpattack: 0,
                        backboard: 0,
                        rob: 0,
                        cover: 0,
                        shoot: 0,
                        shoot_hit: 0,
                        threemin: 0,
                        threemin_hit: 0,
                        punishball: 0,
                        punishball_hit: 0,
                        misplay: 0,
                        foul: 0,
                    },
                    ke: {
                        score: 0,
                        helpattack: 0,
                        backboard: 0,
                        rob: 0,
                        cover: 0,
                        shoot: 0,
                        shoot_hit: 0,
                        threemin: 0,
                        threemin_hit: 0,
                        punishball: 0,
                        punishball_hit: 0,
                        misplay: 0,
                        foul: 0,
                    },
                };
                var fen_ke_arr = Array;
                for (var i = 0; i < re.tlive.length; i++) {
                    var detail = re.tlive[i];
                    var div = "";
                    if (detail.type == 1) {
                        div = $(".home-statistics .statistics-inner .list");
                        fen_arr.zhu = {
                            score: fen_arr.zhu.score + detail.score,
                            helpattack: fen_arr.zhu.helpattack + detail.helpattack,
                            backboard: fen_arr.zhu.backboard + detail.attack + detail.defend,
                            rob: fen_arr.zhu.rob + detail.rob,
                            cover: fen_arr.zhu.cover + detail.cover,
                            shoot: fen_arr.zhu.shoot + detail.shoot,
                            shoot_hit: fen_arr.zhu.shoot_hit + detail.shoot_hit,
                            threemin: fen_arr.zhu.threemin + detail.threemin,
                            threemin_hit: fen_arr.zhu.threemin_hit + detail.threemin_hit,
                            punishball: fen_arr.zhu.punishball + detail.punishball,
                            punishball_hit: fen_arr.zhu.punishball_hit + detail.punishball_hit,
                            misplay: fen_arr.zhu.misplay + detail.misplay,
                            foul: fen_arr.zhu.foul + detail.foul,
                        };
                    } else {
                        div = $(".away-statistics .statistics-inner .list");
                        fen_arr.ke = {
                            score: fen_arr.ke.score + detail.score,
                            helpattack: fen_arr.ke.helpattack + detail.helpattack,
                            backboard: fen_arr.ke.backboard + detail.attack + detail.defend,
                            rob: fen_arr.ke.rob + detail.rob,
                            cover: fen_arr.ke.cover + detail.cover,
                            shoot: fen_arr.ke.shoot + detail.shoot,
                            shoot_hit: fen_arr.ke.shoot_hit + detail.shoot_hit,
                            threemin: fen_arr.ke.threemin + detail.threemin,
                            threemin_hit: fen_arr.ke.threemin_hit + detail.threemin_hit,
                            punishball: fen_arr.ke.punishball + detail.punishball,
                            punishball_hit: fen_arr.ke.punishball_hit + detail.punishball_hit,
                            misplay: fen_arr.ke.misplay + detail.misplay,
                            foul: fen_arr.ke.foul + detail.foul,
                        };
                    }
                    //            if(!detail.onfloor) { //0未出场 1上场
                    //              div.append('<div class="trow row" data-id="'+detail.player_id+'" data-len="' + detail.playtime + '"><div class="w-50"><span>' + detail.number + '</span></div><div class="w-180 name"><span><div><img src="'+detail.photo+'" onerror="javascript:this.src=\'//static.fly2a.com/static/image/b-live/no-img.png\'"></div><span>' + detail.player + '</span></span></div><div class="w-100"><span></span></div><div class="w-100"><span class="trow-playtime">未出场</span></div><div class="w-70"><span class="trow-location">' + detail.location + '</span></div><div class="w-70"><span class="trow-shoot"></span></div><div class="w-70"><span class="trow-threemin"></span></div><div class="w-70"><span class="trow-punishball"></span></div><div class="w-70"><span class="trow-attack"></span></div><div class="w-70 bgc-grey"><span class="trow-defend">&nbsp;</span></div><div class="w-55"><span class="trow-helpattack"></span></div><div class="w-55"><span class="trow-rob"></span></div><div class="w-55"><span class="trow-cover"></span></div><div class="w-55"><span class="trow-misplay"></span></div><div class="w-55"><span class="trow-foul"></span></div><div class="w-58 bgc-grey"><span class="trow-score">&nbsp;</span></div></div>')
                    //            } else {
                    detail.starting = detail.location ? "是" : "否";
                    div.append(
                        '<div class="trow row" data-id="' +
                        detail.player_id +
                        '" data-len="' +
                        detail.playtime +
                        '"><div class="w-50"><span>' +
                        detail.number +
                        '</span></div><div class="w-180 name"><span><div><img src="' +
                        detail.photo +
                        '" onerror="javascript:this.src=\'//static.fly2a.com/static/image/b-live/no-img.png\'"></div><span>' +
                        detail.player +
                        '</span></span></div><div class="w-100"><span>' +
                        detail.starting +
                        '</span></div><div class="w-100"><span class="trow-playtime">' +
                        detail.playtime +
                        '</span></div><div class="w-70"><span class="trow-location">' +
                        detail.location +
                        '</span></div><div class="w-70"><span class="trow-shoot">' +
                        detail.shoot_hit +
                        "-" +
                        detail.shoot +
                        '</span></div><div class="w-70"><span class="trow-threemin">' +
                        detail.threemin_hit +
                        "-" +
                        detail.threemin +
                        '</span></div><div class="w-70"><span class="trow-punishball">' +
                        detail.punishball_hit +
                        "-" +
                        detail.punishball +
                        '</span></div><div class="w-70"><span class="trow-attack">' +
                        detail.attack +
                        '</span></div><div class="w-70 bgc-grey"><span class="trow-defend">' +
                        detail.defend +
                        '</span></div><div class="w-55"><span class="trow-helpattack">' +
                        detail.helpattack +
                        '</span></div><div class="w-55"><span class="trow-rob">' +
                        detail.rob +
                        '</span></div><div class="w-55"><span class="trow-cover">' +
                        detail.cover +
                        '</span></div><div class="w-55"><span class="trow-misplay">' +
                        detail.misplay +
                        '</span></div><div class="w-55"><span class="trow-foul">' +
                        detail.foul +
                        '</span></div><div class="w-58 bgc-grey"><span class="trow-score">' +
                        detail.score +
                        "</span></div></div>"
                    );
                    //            }
                }

                //主球员总结
                $(".home-statistics .statistics-inner .summary").append(
                    '<div class="srow row"><span class="w-100 srow-1">' +
                    fen_arr.zhu.score +
                    '</span><span class="w-100 srow-2">' +
                    fen_arr.zhu.helpattack +
                    '</span><span class="w-100 srow-3">' +
                    fen_arr.zhu.backboard +
                    '</span><span class="w-100 srow-4">' +
                    fen_arr.zhu.rob +
                    '</span><span class="w-100 srow-5">' +
                    fen_arr.zhu.cover +
                    '</span><span class="w-100 srow-6">' +
                    fen_arr.zhu.shoot_hit +
                    "-" +
                    fen_arr.zhu.shoot +
                    '</span><span class="w-100 srow-7">' +
                    fen_arr.zhu.threemin_hit +
                    "-" +
                    fen_arr.zhu.threemin +
                    '</span><span class="w-100 srow-8">' +
                    fen_arr.zhu.punishball_hit +
                    "-" +
                    fen_arr.zhu.punishball +
                    '</span><span class="w-100 srow-9">' +
                    fen_arr.zhu.misplay +
                    '</span><span class="w-100 srow-10">' +
                    fen_arr.zhu.foul +
                    "</span></div>"
                );
                //客球员总结
                $(".away-statistics .statistics-inner .summary").append(
                    '<div class="srow row"><span class="w-100 srow-1">' +
                    fen_arr.ke.score +
                    '</span><span class="w-100 srow-2">' +
                    fen_arr.ke.helpattack +
                    '</span><span class="w-100 srow-3">' +
                    fen_arr.ke.backboard +
                    '</span><span class="w-100 srow-4">' +
                    fen_arr.ke.rob +
                    '</span><span class="w-100 srow-5">' +
                    fen_arr.ke.cover +
                    '</span><span class="w-100 srow-6">' +
                    fen_arr.ke.shoot_hit +
                    "-" +
                    fen_arr.ke.shoot +
                    '</span><span class="w-100 srow-7">' +
                    fen_arr.ke.threemin_hit +
                    "-" +
                    fen_arr.ke.threemin +
                    '</span><span class="w-100 srow-8">' +
                    fen_arr.ke.punishball_hit +
                    "-" +
                    fen_arr.ke.punishball +
                    '</span><span class="w-100 srow-9">' +
                    fen_arr.ke.misplay +
                    '</span><span class="w-100 srow-10">' +
                    fen_arr.ke.foul +
                    "</span></div>"
                );
            }
        },
        shutup() {
            $("#menu").hide();
            var keys = $("#menu").attr("keys");
            var [platform, uid] = keys.replace(/dev_/, '').split('_')
            axios
                .post(
                    COMMOND.NEW_BASE_URL + "mute", {
                    platform,
                    uid
                }, {
                    headers: {
                        Authorization: this.getCookie("token"),
                    },
                }
                )
                .then((res) => {
                    if (res.data.code == 200) {
                        alert("全局禁言成功");
                    } else {
                        alert(res.data.msg);
                    }
                });
        },
        updateShutup() {
            $("#menu").hide();
            var keys = $("#menu").attr("keys");
            updateChatroomMemberTempMute(keys, true);
        },
        close() {
            $("#menu").hide();
        },
        timestampToTime2(timestamp) {
            //时间戳方法 只要月和日
            var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var M =
                (date.getMonth() + 1 < 10 ?
                    "0" + (date.getMonth() + 1) + "/" :
                    date.getMonth() + 1) + "/";
            var D =
                date.getDate() < 10 ? "0" + date.getDate() + "" : date.getDate() + "";
            return M + D;
        },
        live_ajax(ids) {
            var that = this;
            // ***主客赋值先对调,防止以后修改 ,如果改html,css也要改***
            var re = this.matchinfo;
            var countId = undefined;
            var countDown = $(".event-countDown"); //倒计时页面位置
            var homeImg =
                '<img src="' +
                re.home_logo +
                '" onerror="javascript:this.src=\'//static.fly2a.com/static/image/b-live/no-img2.png\'">';
            var awayImg =
                '<img src="' +
                re.away_logo +
                '" onerror="javascript:this.src=\'//static.fly2a.com/static/image/b-live/no-img2.png\'">';

            var isActive = $(".live-tab .tab-1").attr("class").indexOf("active");
            if (isActive != -1 && that.zhibos != 1) {
                $("#iframe1").attr(
                    "src",
                    COMMOND.ANIMATION_URL + "/animation/BasketballAnimation?id=" + ids
                );
            } else {
                $(".live-left .live-tab .tab-2")
                    .addClass("active")
                    .siblings()
                    .removeClass("active");
                $("#iframe1").removeAttr("src");
            }
            //3分球
            $("#bar-1 .left .bar-live").css({
                //百分比
                width: (re.away_threemin_hit /
                    (re.away_threemin_hit + re.home_threemin_hit)) *
                    100 +
                    "%",
            });
            $("#bar-1 .right .bar-live").css({
                width: (re.home_threemin_hit /
                    (re.away_threemin_hit + re.home_threemin_hit)) *
                    100 +
                    "%",
            });
            //2分球
            $("#bar-2 .left .bar-live").css({
                //百分比
                width: (re.away_two_pointst / (re.away_two_points + re.home_two_points)) *
                    100 +
                    "%",
            });
            $("#bar-2 .right .bar-live").css({
                width: (re.home_two_points / (re.away_two_points + re.home_two_points)) *
                    100 +
                    "%",
            });
            //罚球
            $("#bar-3 .left .bar-live").css({
                //百分比
                width: (re.away_punishball_hit /
                    (re.away_punishball_hit + re.home_punishball_hit)) *
                    100 +
                    "%",
            });
            $("#bar-3 .right .bar-live").css({
                width: (re.home_punishball_hit /
                    (re.away_punishball_hit + re.home_punishball_hit)) *
                    100 +
                    "%",
            });
            if (re.tliveuser) {
                //手动直播
                $(".analyst-box").addClass("notAuto");
                $(".analyst-box .up img").attr("src", re.tliveuser.ads);
                $(".analyst-box .analyst-name").html(re.tliveuser.nickname);
                $(".analyst-box .describe").html(re.tliveuser.content);
                $(".analyst-box .analyst-wechar").html(re.tliveuser.weixin);
            }
            if (re.tlive && typeof re.tlive != "string") {
                //自动-传图 手动-传直播员名字
                var last_state = 0;
                for (var _i1 = 0, _ilen = re.tlive.length; _i1 < _ilen; _i1++) {
                    $(".live-text .middle .t-tab" + _ilen).css({
                        display: "block",
                    }); //对应的区域显示
                    var data = re.tlive[_i1];
                    var state = data.state;
                    var div = "";
                    if (
                        state == 1 ||
                        state == 2 ||
                        state == 3 ||
                        state == 4 ||
                        state == 5 ||
                        state == 6 ||
                        state == 7 ||
                        state == -1
                    ) {
                        last_state = state;
                        if ($(".live-text .title .t-tab" + state).length == 0) {
                            $(".live-text .title").append(
                                '<span class="t-tab t-tab' +
                                state +
                                '" data-index="' +
                                state +
                                '">' +
                                stateName[state] +
                                "</span>"
                            );
                            //              $('.live-text .t-tab' + state).attr('data-len', re.tlive[_i1 - 1].length); //给每个切换按钮一个data-len长度,用于动态文字直播判断新增文字用
                        }
                        if (!$(".live-text .t-tab" + state).attr("data-len")) {
                            $(".live-text .t-tab" + state).attr("data-len", 0);
                        } else {
                            $(".live-text .t-tab" + state).attr(
                                "data-len",
                                parseInt($(".live-text .t-tab" + state).attr("data-len")) + 1
                            );
                        }
                        if (data.status == 1) {
                            div =
                                '<img src="' +
                                re.home_logo +
                                '" onerror="javascript:this.src=\'//static.fly2a.com/static/image/b-live/no-img2.png\'">';
                        } else if (data.status == 2) {
                            div =
                                '<img src="' +
                                re.away_logo +
                                '" onerror="javascript:this.src=\'//static.fly2a.com/static/image/b-live/no-img2.png\'">';
                        } else {
                            div = "<div></div>";
                        }

                        $(".live-text .middle .t-tab" + state).prepend(
                            '<li class="situation-1"><i class="line"><i class="radius"></i></i><div class="code">' +
                            data.last_time +
                            '</div><div class="logo">' +
                            div +
                            '</div><div class="score">' +
                            data.home_score +
                            "-" +
                            data.away_score +
                            '</div><div class="tip">' +
                            data.content +
                            "</div></li>"
                        );
                    }
                }
                if (last_state == -1) {
                    var data = re.tlive[re.tlive.length - 1];
                    var state = data.state;
                    $(".live-text .middle .t-tab" + state).prepend(
                        '<li class="situation-1"><i class="line"><i class="radius"></i></i><div class="code">' +
                        data.last_time +
                        '</div><div class="logo"><div></div></div><div class="score">' +
                        data.home_score +
                        "-" +
                        data.away_score +
                        '</div><div class="tip">本场比赛结束，感谢大家关注逛球街，下次再会！</div></li>'
                    );
                }
                $(".live-text .middle .t-tab" + last_state).css("display", "block");
                $(".live-text .title .t-tab:last-child()").addClass("active");
                if ($(".live-text .title .t-tab5")) {
                    $(".live-text .title .t-tab5").html("加时1");
                }
                if ($(".live-text .title .t-tab6")) {
                    $(".live-text .title .t-tab6").html("加时2");
                }
                if ($(".live-text .title .t-tab7")) {
                    $(".live-text .title .t-tab7").html("加时3");
                }
                $(".live-text .middle .noData-img").css({
                    display: "none",
                });
            } else {
                //无数据
                $(".live-text .middle .noData-img").css({
                    display: "block",
                });
            }

            var shijianO = ""; //定义第一次返回的时间

            this.connectSocket(`bmatches_${that.ids}`, (res) => {
                var token = that.getCookie("token");
                //拿到任何消息都说明当前连接是正常的
                if (res.type == "videoad") {
                    if (token && $(".move-ad").attr("data-btn") == 1) {
                        return false;
                    }
                    var result = res.result;
                    var resultType = result.type;
                    var resultParams = result.params;
                    var adhtml = "";
                    // 新增
                    if (resultType == "add") {
                        adhtml +=
                            '<div style="top:' +
                            resultParams["top"] +
                            ";left:" +
                            resultParams["left"] +
                            ";height:" +
                            resultParams["height"] +
                            "px;width:" +
                            resultParams["width"] +
                            'px;" class="box" id=' +
                            resultParams["id"] +
                            " data-url=" +
                            resultParams["image_url"] +
                            " data-imgid=" +
                            resultParams["id"] +
                            ">";
                        adhtml +=
                            '<img src="' +
                            resultParams["image_url"] +
                            '" draggable="false" ondragstart="return false" />';
                        adhtml += "</div>";
                        $(".move-ad").append(adhtml);
                    }
                    // 更新
                    if (resultType == "update") {
                        var domId = "#" + resultParams["id"];
                        $(domId).css("top", resultParams["top"]);
                        $(domId).css("left", resultParams["left"]);
                        $(domId).css("width", resultParams["width"]);
                        $(domId).css("height", resultParams["height"]);
                    }
                    // 删除
                    if (resultType == "delete") {
                        var domId = "#" + resultParams["id"];
                        $(domId).remove();
                    }
                }
                if (res.type == "btlive") {
                    var last_state = 0;
                    var data = res.result;
                    var state = data.state;
                    var div = "";
                    $(".live-text .middle .t-tab" + state).css({
                        display: "block",
                    }); //对应的区域显示
                    if (
                        state == 1 ||
                        state == 2 ||
                        state == 3 ||
                        state == 4 ||
                        state == 5 ||
                        state == 6 ||
                        state == 7 ||
                        state == -1
                    ) {
                        last_state = state;
                        if ($(".live-text .title .t-tab" + state).length == 0) {
                            $(".live-text .title").append(
                                '<span class="t-tab t-tab' +
                                state +
                                '" data-index="' +
                                state +
                                '">' +
                                stateName[state] +
                                "</span>"
                            );
                            //  $('.live-text .t-tab' + state).attr('data-len', re.tlive[_i1 - 1].length); //给每个切换按钮一个data-len长度,用于动态文字直播判断新增文字用
                        }
                        if (!$(".live-text .t-tab" + state).attr("data-len")) {
                            $(".live-text .t-tab" + state).attr("data-len", 0);
                        } else {
                            $(".live-text .t-tab" + state).attr(
                                "data-len",
                                parseInt($(".live-text .t-tab" + state).attr("data-len")) + 1
                            );
                        }
                        if (data.status == 1) {
                            div =
                                '<img src="' +
                                that.matchinfo.home_logo +
                                '" onerror="javascript:this.src=\'//static.fly2a.com/static/image/b-live/no-img2.png\'">';
                        } else if (data.status == 2) {
                            div =
                                '<img src="' +
                                that.matchinfo.away_logo +
                                '" onerror="javascript:this.src=\'//static.fly2a.com/static/image/b-live/no-img2.png\'">';
                        } else {
                            div = "<div></div>";
                        }

                        $(".live-text .middle .t-tab" + state).prepend(
                            '<li class="situation-1"><i class="line"><i class="radius"></i></i><div class="code">' +
                            data.last_time +
                            '</div><div class="logo">' +
                            div +
                            '</div><div class="score">' +
                            data.home_score +
                            "-" +
                            data.away_score +
                            '</div><div class="tip">' +
                            data.content +
                            "</div></li>"
                        );
                    }

                    if (data.state == -1) {
                        var data = res.result;
                        var state = data.state;
                        $(".live-text .middle .t-tab" + state).prepend(
                            '<li class="situation-1"><i class="line"><i class="radius"></i></i><div class="code">' +
                            data.last_time +
                            '</div><div class="logo"><div></div></div><div class="score">' +
                            data.home_score +
                            "-" +
                            data.away_score +
                            '</div><div class="tip">本场比赛结束，感谢大家关注逛球街，下次再会！</div></li>'
                        );
                    }
                    $(".live-text .title .t-tab").removeClass("active");
                    $(".live-text .middle>.event-text").css("display", "none");
                    $(".live-text .middle .t-tab" + last_state).css("display", "block");
                    $(".live-text .title .t-tab:last-child()").addClass("active");
                    if ($(".live-text .title .t-tab5")) {
                        $(".live-text .title .t-tab5").html("加时1");
                    }
                    if ($(".live-text .title .t-tab6")) {
                        $(".live-text .title .t-tab6").html("加时2");
                    }
                    if ($(".live-text .title .t-tab7")) {
                        $(".live-text .title .t-tab7").html("加时3");
                    }
                    $(".live-text .middle .noData-img").css({
                        display: "none",
                    });
                }
                if (res.type == "mute") {
                    res.data.forEach((id) => {
                        $("#dialog [data-fromid$=" + id + "]").remove();
                    });
                }

                if (res.type == "super_vip_member") {
                    if (Array.isArray(res.data) && res.data.length === 1) {
                        this.$set(this.matchinfo, "vip_member", res.data[0]);
                    } else {
                        this.$set(this.matchinfo, "vip_member", false);
                    }
                }
                //球员详情
                if (res.type == "btechnical") {
                    var detail = res.result;
                    var div = "";
                    if (detail.type == 1) {
                        div = $(".home-statistics");
                    } else {
                        div = $(".away-statistics");
                    }
                    var player = div.find('.trow[data-id="' + detail.player_id + '"]');
                    if (player.length > 0) {
                        if (detail.playtime) {
                            player.find(".trow-playtime").text(detail.playtime);
                        }
                        if (detail.location) {
                            player.find(".trow-location").text(detail.location);
                        }
                        if (detail.shoot) {
                            var shoot = div.find(".srow-6").text().split("-");
                            var shoots = player.find(".trow-shoot").text().split("-");
                            var shoot0 = parseInt(shoot[0]);
                            var shoot1 =
                                parseInt(shoot[1]) +
                                (parseInt(detail.shoot) - parseInt(shoots[1]));
                            if (detail.shoot_hit) {
                                shoot0 =
                                    shoot0 + (parseInt(detail.shoot_hit) - parseInt(shoots[0]));
                                shoots[0] = detail.shoot_hit;
                            }
                            player.find(".trow-shoot").text(shoots[0] + "-" + detail.shoot);
                            div.find(".srow-6").text(shoot0 + "-" + shoot1);
                        }
                        if (detail.threemin) {
                            var threemin = div.find(".srow-7").text().split("-");
                            var threemins = player.find(".trow-threemin").text().split("-");
                            var threemin0 = parseInt(threemin[0]);
                            var threemin1 =
                                parseInt(threemin[1]) +
                                (parseInt(detail.threemin) - parseInt(threemins[1]));
                            if (detail.threemin_hit) {
                                threemin0 =
                                    threemin0 +
                                    (parseInt(detail.threemin_hit) - parseInt(threemins[0]));
                                threemins[0] = detail.threemin_hit;
                            }
                            player
                                .find(".trow-threemin")
                                .text(threemins[0] + "-" + detail.threemin);
                            div.find(".srow-7").text(threemin0 + "-" + threemin1);
                        }
                        if (detail.punishball) {
                            var punishball = div.find(".srow-8").text().split("-");
                            var punishballs = player
                                .find(".trow-punishball")
                                .text()
                                .split("-");
                            var punishball0 = parseInt(punishball[0]);
                            var punishball1 =
                                parseInt(punishball[1]) +
                                (parseInt(detail.punishball) - parseInt(punishballs[1]));
                            if (detail.punishball_hit) {
                                punishball0 =
                                    punishball0 +
                                    (parseInt(detail.punishball_hit) - parseInt(punishballs[0]));
                                punishballs[0] = detail.punishball_hit;
                            }
                            player
                                .find(".trow-punishball")
                                .text(punishballs[0] + "-" + detail.punishball);
                            div.find(".srow-8").text(punishball0 + "-" + punishball1);
                        }
                        if (detail.attack) {
                            var attack =
                                parseInt(detail.attack) -
                                parseInt(player.find(".trow-attack").text());
                            player.find(".trow-attack").text(detail.attack);
                            div
                                .find(".srow-3")
                                .text(parseInt(div.find(".srow-3").text()) + attack);
                        }
                        if (detail.defend) {
                            var defend =
                                parseInt(detail.defend) -
                                parseInt(player.find(".trow-defend").text());
                            player.find(".trow-defend").text(detail.defend);
                            div
                                .find(".srow-3")
                                .text(parseInt(div.find(".srow-3").text()) + defend);
                        }
                        if (detail.helpattack) {
                            var helpattack =
                                parseInt(detail.helpattack) -
                                parseInt(player.find(".trow-helpattack").text());
                            player.find(".trow-helpattack").text(detail.helpattack);
                            div
                                .find(".srow-2")
                                .text(parseInt(div.find(".srow-2").text()) + helpattack);
                        }
                        if (detail.rob) {
                            var rob =
                                parseInt(detail.rob) -
                                parseInt(player.find(".trow-rob").text());
                            player.find(".trow-rob").text(detail.rob);
                            div
                                .find(".srow-4")
                                .text(parseInt(div.find(".srow-4").text()) + rob);
                        }
                        if (detail.cover) {
                            var cover =
                                parseInt(detail.cover) -
                                parseInt(player.find(".trow-cover").text());
                            player.find(".trow-cover").text(detail.cover);
                            div
                                .find(".srow-5")
                                .text(parseInt(div.find(".srow-5").text()) + cover);
                        }
                        if (detail.misplay) {
                            var misplay =
                                parseInt(detail.misplay) -
                                parseInt(player.find(".trow-misplay").text());
                            player.find(".trow-misplay").text(detail.misplay);
                            div
                                .find(".srow-9")
                                .text(parseInt(div.find(".srow-9").text()) + misplay);
                        }
                        if (detail.foul) {
                            var foul =
                                parseInt(detail.foul) -
                                parseInt(player.find(".trow-foul").text());
                            player.find(".trow-foul").text(detail.foul);
                            div
                                .find(".srow-10")
                                .text(parseInt(div.find(".srow-10").text()) + foul);
                        }
                        if (detail.score) {
                            var score =
                                parseInt(detail.score) -
                                parseInt(player.find(".trow-score").text());
                            player.find(".trow-score").text(detail.score);
                            div
                                .find(".srow-1")
                                .text(parseInt(div.find(".srow-1").text()) + score);
                        }
                    }
                }
                if (res.type !== "matches") {
                    return;
                }

                var re = res.result;

                if (re.state) {
                    $(".live-title .event-period").html(
                        that.matchinfo.league_id === 8 ?
                            stateNameNcaa[re.state] :
                            stateName[re.state]
                    ); //状态
                    $(".live-content .event-period").html(
                        that.matchinfo.league_id === 8 ?
                            stateNameNcaa[re.state] :
                            stateName[re.state]
                    ); //动画状态
                    //判断完场不显示倒计时
                    if (re.state >= 1 && re.state <= 7) {
                        window.clearInterval(countId);
                        $(".live-title .event-countDown").css({
                            display: "inline-block",
                        });
                        $(".live-content .event-countDown").css({
                            display: "inline-block",
                        });
                    } else {
                        $(".live-title .event-countDown").css({
                            display: "none",
                        });
                        $(".live-content .event-countDown").css({
                            display: "none",
                        });
                    }
                }

                function formatSeconds(value) {
                    //秒转时分秒
                    var theTime = parseInt(value);
                    var theTime1 = 0;
                    if (theTime > 60) {
                        theTime1 = parseInt(theTime / 60);
                        theTime = parseInt(theTime % 60);
                        if (theTime1 > 60) {
                            theTime1 = parseInt(theTime1 % 60);
                        }
                    }
                    if (parseInt(theTime) < 10) {
                        var resultTime = "0" + parseInt(theTime);
                    } else {
                        var resultTime = "" + parseInt(theTime);
                    }
                    if (theTime1 > 0) {
                        if (parseInt(theTime1) < 10) {
                            resultTime = "0" + parseInt(theTime1) + ":" + resultTime;
                        } else {
                            resultTime = "" + parseInt(theTime1) + ":" + resultTime;
                        }
                    } else {
                        resultTime = "00" + ":" + resultTime;
                    }
                    return resultTime;
                }

                if (re.surplus_time) {
                    countDown.html(re.surplus_time);
                }
                if (re.away_score) {
                    $(".live-title .home-score").html(re.away_score); //分数
                    //              $('.live-title .row-one .col-3 span').removeClass('jinqiuColor').addClass('jinqiuColor').html(home_all);
                    $(".live-content .info-two .home-score").html(re.away_score); //动画分数
                }
                if (re.home_score) {
                    $(".live-title .away-score").html(re.home_score);
                    //              $('.live-title .row-two .col-3 span').removeClass('jinqiuColor').addClass('jinqiuColor').html(away_all);
                    $(".live-content .info-two .away-score").html(re.home_score);
                }

                //0三分,1二分,2罚球,3暂停,4犯规,5罚球命中率
                //            $('.live-content .tl-home .pause-num').html(re.stats[3][2]); //暂停
                if (re.away_foul) {
                    $(".live-content .tl-home .ill-num").html(re.away_foul); //犯规
                }
                //            $('.live-content .tr-away .pause-num').html(re.stats[3][1]);
                if (re.home_foul) {
                    $(".live-content .tr-away .ill-num").html(re.home_foul);
                }

                //3分球
                if (re.home_threemin_hit || re.away_threemin_hit) {
                    var away_threemin_hit = parseInt($("#bar-1 .left .num").text());
                    var home_threemin_hit = parseInt($("#bar-1 .right .num").text());
                    if (re.away_threemin_hit) {
                        away_threemin_hit = parseInt(re.away_threemin_hit);
                    }
                    if (re.home_threemin_hit) {
                        home_threemin_hit = parseInt(re.home_threemin_hit);
                    }
                    $("#bar-1 .left .num").html(away_threemin_hit);
                    $("#bar-1 .left .bar-live").css({
                        //百分比
                        width: (away_threemin_hit / (home_threemin_hit + away_threemin_hit)) *
                            100 +
                            "%",
                    });
                    $("#bar-1 .right .num").html(home_threemin_hit);
                    $("#bar-1 .right .bar-live").css({
                        width: (home_threemin_hit / (home_threemin_hit + away_threemin_hit)) *
                            100 +
                            "%",
                    });
                }

                //2分球
                if (re.home_two_points || re.away_two_points) {
                    var away_two_points = parseInt($("#bar-2 .left .num").text());
                    var home_two_points = parseInt($("#bar-2 .right .num").text());
                    if (re.away_two_points) {
                        away_two_points = parseInt(re.away_two_points);
                    }
                    if (re.home_two_points) {
                        home_two_points = parseInt(re.home_two_points);
                    }
                    $("#bar-2 .left .num").html(away_two_points);
                    $("#bar-2 .right .num").html(home_two_points);
                    $("#bar-2 .left .bar-live").css({
                        //百分比
                        width: (away_two_points / (home_two_points + away_two_points)) * 100 +
                            "%",
                    });
                    $("#bar-2 .right .bar-live").css({
                        width: (home_two_points / (away_two_points + home_two_points)) * 100 +
                            "%",
                    });
                }
                //罚球
                if (re.away_punishball_hit) {
                    $("#bar-3 .left .num").html(re.away_punishball_hit);
                    if (re.away_hit_rate) {
                        $("#bar-3 .center .lnum").html(re.away_hit_rate + "%"); //罚球命中率
                    }
                }
                if (re.home_punishball_hit) {
                    $("#bar-3 .right .num").html(re.home_punishball_hit);
                    if (re.home_hit_rate) {
                        $("#bar-3 .center .rnum").html(re.home_hit_rate + "%");
                    }
                }

                if (re.tliveuser) {
                    //手动直播
                    if (!$(".analyst-box").hasClass("notAuto")) {
                        $(".analyst-box").addClass("notAuto");
                        $(".analyst-box .up img").attr("src", re.tliveuser.ads);
                        $(".analyst-box .analyst-name").html(re.tliveuser.nickname);
                        $(".analyst-box .describe").html(re.tliveuser.content);
                        $(".analyst-box .analyst-wechar").html(re.tliveuser.weixin);
                    }
                }
            });

            //文字直播tab栏切换
            $(".live-text .title").on("click", ".t-tab", function () {
                $(this).addClass("active").siblings().removeClass("active");
                $(".live-text .middle .t-tab" + $(this).attr("data-index"))
                    .css({
                        display: "block",
                    })
                    .siblings()
                    .css({
                        display: "none",
                    });
            });

            // 列表动画效果
            //主队 home-h(away-h)是横条  home-v(away-v)是竖条
            $(".home-statistics .list").on("mouseover", ".trow", function () {
                $(".home-h").css({
                    display: "block",
                });
                var oPosition = $(this).position();
                $(".home-h").stop().animate({
                    top: oPosition.top,
                },
                    100,
                    "swing"
                );
            });
            $(".home-statistics .list").on("mouseover", ".trow>div", function () {
                $(".home-v").css({
                    display: "block",
                });
                var oPosition = $(this).position();
                var that = $(this);
                $(".home-v")
                    .stop()
                    .animate({
                        left: oPosition.left,
                        width: that.width(),
                        //竖条高度 = trowHeight(带边框1px) * trowNum
                        height: 48 * ($(".home-statistics .list .trow").length + 1),
                    },
                        100,
                        "swing"
                    );
            });
            $(".home-statistics").on("mouseleave", ".list", function () {
                $(".home-h").css({
                    display: "none",
                });
                $(".home-v").css({
                    display: "none",
                });
            });
            //客队
            $(".away-statistics .list").on("mouseover", ".trow", function () {
                $(".away-h").css({
                    display: "block",
                });
                var oPosition = $(this).position();
                $(".away-h").stop().animate({
                    top: oPosition.top,
                },
                    100,
                    "swing"
                );
            });
            $(".away-statistics .list").on("mouseover", ".trow>div", function () {
                $(".away-v").css({
                    display: "block",
                });
                var oPosition = $(this).position();
                var that = $(this);
                $(".away-v")
                    .stop()
                    .animate({
                        left: oPosition.left,
                        width: that.width(),
                        //竖条高度 = trowHeight(带边框1px) * trowNum
                        height: 48 * ($(".away-statistics .list .trow").length + 1),
                    },
                        100,
                        "swing"
                    );
            });
            $(".away-statistics").on("mouseleave", ".list", function () {
                $(".away-h").css({
                    display: "none",
                });
                $(".away-v").css({
                    display: "none",
                });
            });
        },
        chat_ajax() {
            var ids = this.ids;
            $.ajax({
                url: "https://task.guangqiujie.com/v1/chat",
                data: {
                    id: ids,
                },
                success: function (res) {
                    var re = res.result;
                    for (var i = 0, ilen = re.length; i < ilen; i++) {
                        var className = "loginname";
                        //              re[i].status == 1 //不是机器人
                        if (getCookie("type") == 2 && re[i].status == 1) {
                            className = "loginrealname";
                            $("#dialog")
                                .append(
                                    '<li><span class="' +
                                    className +
                                    '" keys="' +
                                    re[i].keys +
                                    '" oncontextmenu="contextMenu(event)">' +
                                    re[i].client_name +
                                    "</span><span>: </span>" +
                                    re[i].content +
                                    "</li>"
                                )
                                .parseEmotion();
                        } else {
                            if (getCookie("keys") == re[i].keys) {
                                className = "loginrealname";
                            }
                            $("#dialog")
                                .append(
                                    '<li><span class="' +
                                    className +
                                    '" keys="' +
                                    re[i].keys +
                                    '">' +
                                    re[i].client_name +
                                    "</span><span>: </span>" +
                                    re[i].content +
                                    "</li>"
                                )
                                .parseEmotion();
                        }
                    }
                    scrollToLocation(); //初始化滚动底部
                    $("#dialog").on("mouseenter", function (e) {
                        e.preventDefault();
                        chat_enter = true;
                    });
                    $("#dialog").on("mouseleave", function (e) {
                        e.preventDefault();
                        chat_enter = false;
                    });
                    $("#menu").on("mouseenter", function (e) {
                        e.preventDefault();
                        chat_enter = true;
                    });
                    $("#menu").on("mouseleave", function (e) {
                        e.preventDefault();
                        chat_enter = false;
                    });
                },
            });
        },
        adv(url) {
            //鼠标移入消失广告事件
            if (url == "1") {
                $(".adv").css({
                    display: "block",
                });
                $(".live-box")
                    .on("mouseenter", "#iframe2", function () {
                        //是乐虎直播鼠标移入显示广告
                        $(".adv").css({
                            display: "none",
                        });
                    })
                    .on("mouseleave", "#iframe2", function () {
                        $(".adv").css({
                            display: "block",
                        });
                    });
            } else {
                $(".adv").css({
                    display: "none",
                });
                $(".live-box")
                    .on("mouseenter", "#iframe2", function () {
                        //不是乐虎直播鼠标移入不显示广告
                        $(".adv").css({
                            display: "none",
                        });
                    })
                    .on("mouseleave", "#iframe2", function () {
                        $(".adv").css({
                            display: "none",
                        });
                    });
            }
        },
        createdChatroom(chatroomid) {
            if (!this.getCookie("yk_token") && !this.getCookie("netease_im_token")) {
                this.getykmsg(chatroomid);
                return;
            }
            this.chatroomid = chatroomid;
            var netease_im_token = this.getCookie("netease_im_token") ?
                this.getCookie("netease_im_token") :
                this.getCookie("yk_token");
            this.netease_im_token = this.getCookie("netease_im_token");
            sessionStorage.setItem("chatroomid", chatroomid);
            var member_id = this.getCookie("member_id") ?
                COMMOND.DEV + this.getCookie("member_id") :
                this.getCookie("yk_account");
            onChatroomConnect(member_id, netease_im_token, chatroomid, this.getykmsg);
        },
        getykmsg(chatroomid) {
            if (!this.getCookie("netease_im_token")) {
                axios.get(COMMOND.NEW_BASE_URL + "get_visitor").then((res) => {
                    //              console.log(res)
                    var data = res.data.data;
                    this.setCookie1("yk_name", data.nick_name);
                    this.setCookie1("yk_account", data.accid);
                    this.setCookie1("yk_token", data.token);
                    // this.createdChatroom(chatroomid);
                });
            }
        },
        tabBtn(index) {
            this.tab = index;
            $("#iframe1").removeAttr("src");
            $("#iframe2").removeAttr("src");
            this.tv_pitch_On = 0;
            $(".b-live").click();
            //        console.log($("body").click())
            if (index == 2) {
                if (this.tvlines.length == 1) {
                    this.tv_pitch_On = this.tvlines[0].id;
                    var url = this.tvlines[0].url;
                    if (url) {
                        $("#iframe2").attr("src", COMMOND.VIDEO_URL + this.tvlines[0].id);
                    } else {
                        this.tvlines = [];
                    }
                    $("#iframe2").css("display", "block");
                    this.member_id = this.tvlines[0].member_id;
                    this.currAnchor.name = this.tvlines[0].username;
                    this.currAnchor.face = this.tvlines[0].face;
                    this.currAnchor.room_id = this.tvlines[0].ws_room_id;
                    this.currAnchor.roomid = this.tvlines[0].roomid;
                    this.currAnchor.member_id = this.tvlines[0].member_id;
                    this.currAnchor.wx_num = this.tvlines[0].wx_num;
                    this.currAnchor.type = this.tvlines[0].type;
                    this.currAnchor.wx_code = this.tvlines[0].wx_code;
                    this.currAnchor.qrcode = this.tvlines[0].qrcode;
             
                    if (this.matchinfo.roomid == this.tvlines[0].roomid) {
                        this.currAnchor.name = "公共";
                        this.currAnchor.room_id = this.matchinfo.ws_room_id;
                        this.currAnchor.roomid = this.matchinfo.roomid;
                    }
                    this.currAnchor.room_user_num = this.tvlines[0].room_user_num;
                    if (
                        this.tvlines[0].roomid &&
                        this.chatroomid != this.tvlines[0].roomid
                    ) {
                        this.currAnchor.room_id = this.tvlines[0].ws_room_id
                        this.currAnchor.roomid = this.tvlines[0].roomid
                        // this.createdChatroom(this.tvlines[0].roomid);
                    } else {
                        if (!this.tvlines[0].roomid) {
                            this.netease_im_token = 1;
                            layer.open({
                                content: "暂无" + this.tvlines[0].username + "的聊天室",
                            });
                        }
                    }
                    //            this.setViewer(this.ids,2,this.member_id);
                    axios.post(
                        COMMOND.NEW_BASE_URL + "add_sta",
                        "type=1&page=lanqiu_live&device=pc&tournament_id=" +
                        this.ids +
                        "&member_id=" +
                        this.member_id
                    );
                } else if (this.tvlines.length > 1) {
                    //            if(this.tvid){
                    //              for (var i=0; i<this.tvlines.length; i++) {
                    //                if(this.tvlines[i].id==this.tvid){
                    //                  this.tabCurrUrl(this.tvlines[i]);
                    //                  this.tvid = 0;
                    ////                  history.pushState("", "", "/lanqiu/live?id=" + this.ids + "&zhibo=1");
                    //                  break;
                    //                }
                    //                if(i==this.tvlines.length-1){
                    //                  $('#iframe2').css("display","none");
                    //                    $('.tv_outer').css("display","block");
                    //                    if(this.matchinfo.roomid&&this.chatroomid != this.matchinfo.roomid){
                    //                      this.currAnchor.name = '';
                    //                    this.createdChatroom(this.matchinfo.roomid)
                    //                  }
                    //                    if(this.member_id){
                    //                      axios.post(COMMOND.NEW_BASE_URL + 'add_sta','type=2&page=lanqiu_live&device=pc&tournament_id='+this.ids+'&member_id='+this.member_id);
                    //                      this.member_id = 0;
                    //                    }
                    //                }
                    //              }
                    //            }else{
                    $("#iframe2").css("display", "none");
                    $(".tv_outer").css("display", "block");
                    if (
                        this.matchinfo.roomid &&
                        this.chatroomid != this.matchinfo.roomid
                    ) {
                        this.currAnchor.name = "公共";
                        this.currAnchor.room_user_num = this.matchinfo.room_user_num;
                        this.currAnchor.room_id = this.matchinfo.ws_room_id;
                        this.currAnchor.roomid = this.matchinfo.roomid;
                        // this.createdChatroom(this.matchinfo.roomid);
                    }
                    if (this.member_id) {
                        axios.post(
                            COMMOND.NEW_BASE_URL + "add_sta",
                            "type=2&page=lanqiu_live&device=pc&tournament_id=" +
                            this.ids +
                            "&member_id=" +
                            this.member_id
                        );
                        this.member_id = 0;
                    }
                    //              }
                } else {
                    $("#iframe2").css("display", "none");
                    $(".tv_outer").css("display", "none");
                    $("#noZhibo").css("display", "block");
                    if (
                        this.matchinfo.roomid &&
                        this.chatroomid != this.matchinfo.roomid
                    ) {
                        this.currAnchor.name = "公共";
                        this.currAnchor.room_user_num = this.matchinfo.room_user_num;
                        this.currAnchor.room_id = this.matchinfo.ws_room_id;
                        this.currAnchor.roomid = this.matchinfo.roomid;
                        // this.createdChatroom(this.matchinfo.roomid);
                    }
                }
            } else {
                $("#iframe1").attr(
                    "src",
                    COMMOND.ANIMATION_URL +
                    "/animation/BasketballAnimation?id=" +
                    this.ids
                );
                this.currAnchor.name = "公共";
                this.currAnchor.room_user_num = this.matchinfo.room_user_num;
                this.currAnchor.room_id = this.matchinfo.ws_room_id;
                this.currAnchor.roomid = this.matchinfo.roomid;
                if (this.matchinfo.roomid && this.chatroomid != this.matchinfo.roomid) {
                    // this.createdChatroom(this.matchinfo.roomid);
                    this.currAnchor.room_id = this.matchinfo.ws_room_id;
                    this.currAnchor.roomid = this.matchinfo.roomid;
                } else {
                    if (!this.matchinfo.roomid) {
                        this.netease_im_token = 1;
                        layer.open({
                            content: "暂无2D聊天室",
                        });
                    }
                }
                if (this.member_id) {
                    axios.post(
                        COMMOND.NEW_BASE_URL + "add_sta",
                        "type=2&page=lanqiu_live&device=pc&tournament_id=" +
                        this.ids +
                        "&member_id=" +
                        this.member_id
                    );
                    this.member_id = 0;
                }
            }
        },
        setViewer(tournament_id, type, member_id) {
            var url = COMMOND.NEW_BASE_URL + "viewer";
            axios
                .post(
                    url, {
                    tournament_id: tournament_id,
                    type: type,
                    member_id: member_id,
                }, {
                    headers: {
                        clientType: "pc",
                    },
                }
                )
                .then((res) => { });
        },
        tabCurrUrl(item) {
            //切换主播
            // if (!onCanConnect()) {
            //     layer.msg("切换太快啦，请慢点切换！");
            //     return;
            // }
            if (this.timing || this.tvid == item.id) {
                if (this.tab != 2) {
                    this.tab = 2;
                    $("#iframe1").removeAttr("src");
                    $("#iframe2").removeAttr("src");
                    this.tv_pitch_On = 0;
                }
                var url = item.url;
                var member_id = this.member_id;
                $(".addUrlForm-outer").css("display", "none");
                $(".tv_outer").css("display", "none");
                $("#iframe2").css("display", "block");
                this.tv_pitch_On = item.id;
                if (url) {
                    $("#iframe2").attr("src", COMMOND.VIDEO_URL + item.id);
                    this.member_id = item.member_id;
                    if (member_id != this.member_id) {
                        this.currAnchor.name = item.username;
                        this.currAnchor.face = item.face;
                        this.currAnchor.room_id = item.ws_room_id;
                        this.currAnchor.roomid = item.roomid;
                        this.currAnchor.member_id = item.member_id;
                        this.currAnchor.wx_num = item.wx_num;
                        this.currAnchor.type = item.type;
                        this.currAnchor.wx_code = item.wx_code;
                        this.currAnchor.qrcode = item.qrcode;

                        if (this.matchinfo.roomid == item.roomid) {
                            this.currAnchor.name = "公共";
                            this.currAnchor.room_id = this.matchinfo.ws_room_id;
                            this.currAnchor.roomid = this.matchinfo.roomid;
                        }
                        this.currAnchor.room_user_num = item.room_user_num;
                        if (item.roomid && this.chatroomid != item.roomid) {
                            // this.createdChatroom(item.roomid);
                            this.currAnchor.room_id = item.ws_room_id;
                            this.currAnchor.roomid = item.roomid;
                        } else {
                            if (!item.roomid) {
                                this.netease_im_token = 1;
                                layer.open({
                                    content: "暂无" + item.username + "的聊天室",
                                });
                            }
                        }
                        //              this.setViewer(this.ids,2,this.member_id);
                        axios.post(
                            COMMOND.NEW_BASE_URL + "add_sta",
                            "type=1&page=zuqiu_live&device=pc&tournament_id=" +
                            this.ids +
                            "&member_id=" +
                            this.member_id
                        );
                    }
                } else {
                    if (item.type == 2) {
                        $("#noZhibo div img").attr(
                            "src",
                            "//static.fly2a.com/static/image/b-live/zhubo-nostart.png"
                        );
                    } else {
                        $("#iframe2").css({
                            display: "none",
                        });
                        $("#noZhibo").css({
                            display: "block",
                        });
                    }
                    if (
                        this.matchinfo.roomid &&
                        this.chatroomid != this.matchinfo.roomid
                    ) {
                        this.currAnchor.name = "公共";
                        this.currAnchor.room_user_num = this.matchinfo.room_user_num;
                        this.currAnchor.room_id = this.matchinfo.ws_room_id;
                        this.currAnchor.roomid = this.matchinfo.roomid;
                        // this.createdChatroom(this.matchinfo.roomid);
                    }
                }
                if (member_id && member_id != this.member_id) {
                    this.currAnchor.isnofollow = 1;
                    axios.post(
                        COMMOND.NEW_BASE_URL + "add_sta",
                        "type=2&page=zuqiu_live&device=pc&tournament_id=" +
                        this.ids +
                        "&member_id=" +
                        member_id
                    );
                }
            }
        },
        handleLabel(label) {
            return label.replace(",", "<br>").replace("，", "<br>");
        },
        swippertab() {
            //轮播图初始化
            var mySwiper = new Swiper(".swiper-container", {
                nextButton: ".swiper-button-next",
                prevButton: ".swiper-button-prev",
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
            });
        },
        adv2() {
            var that = this;
            // 大横幅遮挡广告
            var lefttime = 5 * 60 * 1000;

            function checkAdBanner() {
                if (lefttime > 2 * 60 * 1000) {
                    // console.log(lefttime);
                    $("#adBanner").css({
                        display: "block",
                    });
                } else {
                    $("#adBanner").css({
                        display: "none",
                    });
                    clearInterval(timer1);
                    if (lefttime > -3000) {
                        //                      window.location.reload();
                    }
                }
            }
            var timer1 = "";
            if (lefttime > 0) {
                timer1 = setInterval(checkAdBanner, 5000);
            }
            var tournament_id = 0;
            $(function () {
                var url = window.location.href; //获取url的id
                var url_arr = 0;
                if (url.indexOf("?") != -1) {
                    url_arr = that.ids;
                }
                tournament_id = url_arr;
                $("#addUrlForm").find("input[name=tournament_id]").val(tournament_id);
                getZhibo(tournament_id);
            });

            function getZhibo(tournament_id) {
                var token = that.getCookie("token");
                var member_id = that.getCookie("member_id");
                if (!member_id) {
                    member_id = "";
                }
                if (!token) {
                    return;
                }
                $.ajax({
                    type: "GET",
                    dataType: "json",
                    headers: {
                        Authorization: token,
                    },
                    url: COMMOND.NEW_BASE_URL + "getzhibo",
                    success: function (res) {
                        $(".move-ad").attr("data-btn", res.data.showAddBtn);
                        if (res.data.showAddBtn == 1) {
                            //                console.log(res.data.member.type);
                            if (that.memberType == 9) {
                                $(".move-ad").css("height", "20%");
                            }
                            // $("#formStr")
                            //   .html(res.data.formStr)
                            //   .find("input")
                            //   .attr("autocomplete", "off");
                            // $("#formStr #currMember").after("<br/>");
                            // $("#formStr #url").on("keydown", function (e) {
                            //   if (e.keyCode === 13 && !e.ctrlKey) {
                            //     // 按enter键提交
                            //     that.submitUrlForm();
                            //   }
                            // });
                            //                          $('#formStr #member_id').clone(true).appendTo("#addUrlForm");
                        } else {
                            $(".move-ad").css("height", "0");
                        }
                    },
                });
            }
        },
        // 设为默认播放地址
        //      setDefault() {
        //        var tvid = $('#tvid').val();
        //        if(tvid == '') {
        //          alert('空地址不能设为默认');
        //          return;
        //        }
        //
        //        $.ajax({
        //          type: "POST",
        //          dataType: "json",
        //          headers: {
        //            'token': getCookie('token')
        //          },
        //          data: {
        //            'tvid': tvid
        //          },
        //          url: that.BASE_URL + "zhibo/setdefault",
        //          success: function(res) {
        //            window.location.reload();
        //          }
        //        });
        //
        //      },
        showAddUrl() {
            // 弹出增加窗口
            this.tabBtn(2);
            if (this.tvlines.length >= 5) {
                alert("开播人数已满，不可再申请开播！");
                return;
            }
            if ($(".addUrlForm-outer").attr("style") == "display:none;") {
                var member_id = this.getCookie("member_id");
                if (this.memberType == 2) {
                    for (var i = 0; i < this.tvlines.length; i++) {
                        if (member_id == this.tvlines[i].member_id) {
                            alert("已开播，不可重复开播！");
                            return;
                        }
                    }
                }
                $("#member_id").val(member_id);
                $(".addUrlForm-outer").attr("style", "display:block;");
                $("#member_id").css({
                    display: "",
                });
                $("#currMember").html("");
                $("#addUrlForm a").css("display", "inline-block");
                if ($("#issuper").val() > 0) {
                    $("#tvid").val("");
                    $("#url").val("");
                }
            } else {
                $(".addUrlForm-outer").attr("style", "display:none;");
            }
        },
        setCookie1(name, value) {
            document.cookie = name + "=" + value + ";path=/";
        },
        getCookie(name) {
            var arr = document.cookie.split("; ");
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split("=");
                if (arr2[0] == name) {
                    return arr2[1];
                }
            }
            return "";
        },
        getAnchors() {
            if (this.minfo.type == 9 && this.modal.options.length == 0) {
                const token = this.getCookie("token");
                $.ajax({
                    url: "/api/anchor_list",
                    sync: true,
                    headers: {
                        Authorization: token,
                    },
                    success: (res) => {
                        this.modal.options = res.data || [];
                    },
                });
            }
        },
        showAddUrl(el) {
            const { minfo, matchinfo } = this;
            const tv =
                (matchinfo.tv || []).find(
                    (v) => v.member_id != 133 && v.member_id == minfo.member_id
                ) || {};
            this.getAnchors();
            this.modal.data.member_id = minfo.type == 9 ? undefined : minfo.member_id;
            this.modal.data.url = tv.url || "";
            this.modal.data.tvid = tv.id || "";
            this.modal.visible = true;
        },
        updateUrl(item) {
            if (this.minfo.type == 9) {
                this.getAnchors();
                this.modal.data.tvid = item.id;
                this.modal.data.url = item.url;
                this.modal.data.member_id = item.member_id;
                this.modal.visible = true;
            }
        },
        createUrl() {
            const { modal, matchinfo, minfo, ids } = this;
            const token = this.getCookie("token");
            const data = {
                tournament_id: ids,
                tournament_type: 1,
                tvid: modal.data.tvid || undefined,
                url: modal.data.url || "",
                member_id: modal.data.member_id || minfo.member_id,
                sort: 1,
            };
            const loading = this.$loading({ text: "加载中..." });
            $.ajax({
                type: "Get",
                dataType: "json",
                headers: {
                    Authorization: token,
                },
                url: "/api/add_url",
                data: data,
                success: (res) => {
                    if (res.code == 200) {
                        window.location.reload();
                    } else {
                        alert(res.msg);
                    }
                },
                complete: () => {
                    loading.close();
                },
            });
        },
        removeUrl() {
            this.modal.data.url = "";
            this.createUrl();
        },
    },
    metaInfo() {
        return {
            title: this.headCon["lanqiu"]["live"]["title"],
            script: [{
                src: "/static/js/f-chat.js",
            }, //聊天长连接
            {
                src: "//static.fly2a.com/static/lib/chat/js/swfobject.js",
            },
            {
                src: "//static.fly2a.com/static/lib/chat/js/web_socket.js",
            },
            {
                src: "//static.fly2a.com/static/lib/chat/js/jquery-sinaEmotion-2.1.0.min.js",
            },
            {
                src: "//static.fly2a.com/static/js/jquery.base64.min.js",
            },
            ],
            link: [{
                rel: "stylesheet",
                href: "//static.fly2a.com/static/lib/chat/css/jquery-sinaEmotion-2.1.0.min.css",
            },
            {
                rel: "stylesheet",
                href: "//static.fly2a.com/static/lib/chat/css/style.css",
            },
            ],
            meta: [{
                hid: "description",
                name: "description",
                content: this.headCon["lanqiu"]["live"]["description"],
            },
            {
                hid: "keywords",
                name: "keywords",
                content: this.headCon["lanqiu"]["live"]["keywords"],
            },
            ],
        };
    },
};
</script>
<style>
@import "../../assets/css/b-live.css";
</style>